/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiUserColumnsRequest
 */
export interface ApiUserColumnsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof ApiUserColumnsRequest
     */
    columns: Array<string> | null;
}

export function ApiUserColumnsRequestFromJSON(json: any): ApiUserColumnsRequest {
    return ApiUserColumnsRequestFromJSONTyped(json, false);
}

export function ApiUserColumnsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiUserColumnsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'columns': json['columns'],
    };
}

export function ApiUserColumnsRequestToJSON(value?: ApiUserColumnsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'columns': value.columns,
    };
}

